import store from '../store';

/**
 * 通用工具接口API
 */
export default {
    /**
     * 上传
     * @param {*} payload
     * @returns
     */
    async upload (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/common/upload';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }

        // 获取URL
        let url = null;
        let json = await resp.json();
        if (json && json.statusCode === 200 && json.opDesc) {
            url = json.opDesc;
        }
        if (!url) {
            throw new Error('上传失败，未获取到图片地址');
        }
        return url;
    }
};
